// Page.jsx
import React from "react";
import { Container, Box, Grid, Typography } from "@mui/material";
import AccountSidebarNav from "../../Components/AccountComponents/AccountSideNacv";
import PersonalDetailForm from "../../Components/AccountComponents/PersonalDetailForm";

export default function PersonalDetail() {
    return (
        <Container maxWidth={false}
            sx={{
                py: 2,
                // Responsive maxWidth for different screen sizes
                maxWidth: {
                    xs: '100%',  // Mobile
                    sm: '95%',   // Small tablets
                    md: '92%',   // Tablets and small laptops
                    lg: '90%',   // Large screens
                    xl: '90%',   // Very large displays
                },
                mx: 'auto', // Center align container
            }}>
            {/* Breadcrumb */}
            <Box
                sx={{
                    mb: 2,
                    pb: 2,
                    borderBottom: "1px solid #e5e5e5",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        textTransform: "uppercase",
                        fontSize: "12px",
                        letterSpacing: "0.05em",
                        color: "text.secondary",
                    }}
                >
                    <span style={{ color: "#000" }}>My Account</span>
                    <span style={{ margin: "0 8px" }}>{">"}</span>
                    <span style={{ color: "#000" }}>Personal Details</span>
                </Typography>
            </Box>

            {/* Main Layout */}
            <Grid container spacing={4}>
                {/* Left Sidebar */}
                <Grid item xs={12} md={3}>
                    <AccountSidebarNav active="Personal Details" />
                </Grid>

                {/* Right Content */}
                <Grid item xs={12} md={9}>
                    <Box sx={{ mb: 3 }}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                textTransform: "uppercase",
                                fontWeight: 600,
                                letterSpacing: "0.05em",
                                color: "text.primary",
                                fontSize: "14px",
                            }}
                        >
                            My Details
                        </Typography>
                    </Box>

                    <Grid container spacing={4}>
                        <Grid item xs={12} lg={3}>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <PersonalDetailForm />
                        </Grid>
                        <Grid item xs={12} lg={3}>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    );
}
